import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { OrderPageRoutingModule } from './order-routing.module';
import { OrderPage } from './order.page';
import { SharedModule } from '../shared/shared.module';
import { PoPopoverComponent } from './components/purchase-order/po-popover-desktop/po-popover.component';
import { SubmitModalMobileComponent } from './components/submit-modal-mobile/submit-modal-mobile.component';
import { PoPopoverMobileComponent } from './components/purchase-order/po-popover-mobile/po-popover-mobile.component';
import { ChangePoComponent } from './components/purchase-order/change-po/change-po.component';
import { PopoverHelperService } from '../shared/helpers/popover.helpers';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EffectsModule } from '@ngrx/effects';
import { ClientOrderEffects } from './effects/client-order.effects';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { OrderExceptionsPageModule } from './pages/order-exceptions/order-exceptions.module';
import { OrderHeaderEffects } from './effects/order-header-effects';
import { WmtPopoverComponent } from './components/wmt-popover/wmt-popover.component';
import { SubmittedOrderResolverService } from './services/order-submitted-resolver.service';
import { OrderTracingEffects } from './tracking/tracing/order-tracing.effects';
import { OrderExceptionsTracingEffects } from './pages/order-exceptions/tracking/tracing/order-exceptions-tracing.effects';
import { OrderAnalyticsEffects } from './tracking/analytics/order-analytics.effects';
import { CartEffects } from './effects/cart.effects';
import { CartSyncTracingEffects } from './tracking/tracing/cart/cart-sync/cart-sync-tracing.effects';
import { CartAnalyticsEffects } from './tracking/analytics/cart/cart-analytics.effects';
import { CartTracingEffects } from './tracking/tracing/cart/cart-tracing.effects';
import { ImportOrderValidationClientEffects } from './pages/import-order-validation/effects/import-order-validation.effects';
import { ImportOrderValidationAnalyticsEffects } from './pages/import-order-validation/tracking/analytics/import-order-validation-analytics.effects';
import { ImportOrderUploadAnalyticsEffects } from '@shared/components/import-order/tracking/analytics/import-order-upload-analytics.effects';
import { DealsPageModule } from '@app/deals/deals.module';
import { OrderInsightsEffects } from './effects/order-insights.effects';
import { AdditionalInstructionsModalComponent } from './components/additional-instructions-modal/additional-instructions-modal.component';
import { ClientEditCartEffects } from './effects/client-edit-cart.effects';
import { DsmClientEffects } from './effects/dsm.effects';

export const httpLoaderFactory = (http: HttpClient) =>
  new TranslateHttpLoader(http, 'assets/i18n/', '.json');
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    OrderPageRoutingModule,
    MatRadioModule,
    OrderExceptionsPageModule,
    EffectsModule.forFeature([
      ClientOrderEffects,
      OrderHeaderEffects,
      OrderTracingEffects,
      OrderExceptionsTracingEffects,
      OrderAnalyticsEffects,
      CartEffects,
      CartSyncTracingEffects,
      CartAnalyticsEffects,
      CartTracingEffects,
      ImportOrderValidationClientEffects,
      ImportOrderValidationAnalyticsEffects,
      ImportOrderUploadAnalyticsEffects,
      OrderInsightsEffects,
      ClientEditCartEffects,
      DsmClientEffects,
    ]),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    DealsPageModule,
  ],
  declarations: [
    OrderPage,
    PoPopoverComponent,
    PoPopoverMobileComponent,
    SubmitModalMobileComponent,
    ChangePoComponent,
    WmtPopoverComponent,
    AdditionalInstructionsModalComponent,
  ],
  providers: [PopoverHelperService, SubmittedOrderResolverService],
})
export class OrderPageModule {}
